export default (builder) =>
  builder.query({
    query: ({ collectionName }) => ({
      url: `/file-collections/${collectionName}/validate`,
      method: 'GET',
    }),
  });
